import styled from 'styled-components';

export const ContentAction = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  h6 {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const StudentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;

  img,
  > div:first-child {
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
  }
`;

export const StudentInfo = styled.div`
  display: flex;
  flex-direction: column;

  span {
    ${(props) => props.theme.config.typograph.default};
    font-weight: bold;
    color: ${(props) => props.theme.config.colors.text_base};
  }
`;

export const StudentTag = styled.span`
  ${(props) => props.theme.config.typograph.mico};
  color: ${(props) => props.theme.config.colors.primary};
  font-weight: bold;
`;
export const TestName = styled.span`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.primary} !important;
  font-weight: normal;
`;

export const StudentHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

export const StudentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  h6 {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
    white-space: nowrap;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 20rem;
  gap: 1.6rem;
`;

export const EmptyStateButton = styled.div`
  margin-top: 0.8rem;
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ChartToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ChartArea = styled.div`
  flex: 1;
  min-height: 0;
  height: calc(100% - 4rem);
`;
